module.exports = __webpack_public_path__ + "static/media/alerts.1000c2b7.svg";